import { statusToneOrNeutral } from '@bookingdei/i18n/status-tone';
import { tone } from '../theme/tokens';

// Booking status → chip colours (CB-15): the canonical tone from packages/i18n,
// resolved to this surface's tone tokens. Unknown wire values are neutral (AP-D10).
// Used where a screen colours something other than a StatusBadge (calendar events,
// schedule dots, legends).
export function bookingToneColors(status: string): { bg: string; fg: string; solid: string } {
  return tone[statusToneOrNeutral('booking_status', status)];
}
